import React from 'react';

import { di } from 'react-magnetic-di';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';
import ReactRenderer from '@atlaskit/renderer/renderer';

import { asFormAdfField } from '../../../../../../../../common/types/form/form-fields/utils';
import type { FormFieldComponentRendererProps } from '../../../../../../../../common/types/renderers';
import { useFormField } from '../../../../../../../../controllers/form-renderer-store';

const boxStyles = xcss({
	borderStyle: 'solid',
	borderColor: 'color.border.disabled',
	borderRadius: 'radius.small',
	borderWidth: 'border.width',
	backgroundColor: 'color.background.disabled',
	padding: 'space.075',
	minHeight: '100px',
});

export const PreviewParagraphRichTextInput = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	di(useFormField);
	const formField = useFormField({ fieldId });
	const formAdfField = asFormAdfField(formField);

	if (formAdfField === undefined) {
		return <></>;
	}

	return (
		<Box xcss={boxStyles} testId={`field-input-paragraph-rich-text-preview-${fieldId}`}>
			{formAdfField.value?.adf && <ReactRenderer document={formAdfField.value?.adf} />}
		</Box>
	);
};
